export const staffNavigationGroups = [
  {
    id: 'workspace',
    label: 'Area di lavoro',
    items: [
      { id: 'dashboard', label: 'Dashboard', description: 'Promemoria e attività', icon: 'home', to: '/dashboard', isNew: false },
      { id: 'nutrition', label: 'Nutrizione', description: 'Ticket nutrizionali', icon: 'confirmation_number', to: '/admin', isNew: false },
      { id: 'technical', label: 'Tecnica', description: 'Assistenza e ticket', icon: 'fitness_center', to: '/assistenzatecnica', isNew: false },
      { id: 'orders', label: 'Ordini', description: 'Ordini e acquisti', icon: 'shopping_bag', to: '/order-list-new', isNew: false },
      { id: 'bookings', label: 'Prenotazioni', description: 'Calendari e appuntamenti', icon: 'event', to: '/booking-general', isNew: false },
      { id: 'users', label: 'Utenti', description: 'Profili e anagrafiche', icon: 'people', to: '/users-list', isNew: false },
    ],
  },
  {
    id: 'monitoring',
    label: 'Monitoraggio',
    items: [
      { id: 'sends', label: 'Invii di giornata', description: 'Monitoraggio giornaliero', icon: 'done_all', to: '/invii-giornata', isNew: false },
      { id: 'changes', label: 'Invii da modificare', description: 'Richieste di modifica', icon: 'edit_note', to: '/invii-da-modificare', isNew: true },
    ],
  },
  {
    id: 'administration',
    label: 'Amministrazione',
    items: [
      { id: 'management', label: 'Gestione', description: 'Strumenti e impostazioni', icon: 'tune', to: '/gestione-general', isNew: false },
    ],
  },
];

const sectionPaths = {
  dashboard: [
    '/dashboard', '/promemoria-pubblico', '/notifiche-10-giorni', '/notifiche-24-giorni',
    '/notifiche-40-giorni', '/programmi-da-oscurare', '/notifiche-45-giorni',
  ],
  nutrition: ['/admin', '/ticketsrisposti'],
  technical: ['/assistenzatecnica', '/assistenzatecnica-nascosta', '/assistenzatecnica-nascosta-ricerca'],
  orders: [
    '/order-list-new', '/orders-general', '/order-list', '/order', '/create-order', '/order-summary',
    '/orders-analytics', '/orders-accounting', '/rate-manuali', '/ordini-pt-export', '/uscite',
  ],
  bookings: [
    '/booking-general', '/prenotazioni-pubbliche', '/booking-list', '/videocall-list',
    '/videocall-list-booking', '/calendari-eventi',
  ],
  users: ['/users-list', '/users-influencer-list', '/users-top-list', '/users-expiring-list', '/createusers'],
  sends: ['/invii-giornata', '/invii-giornata-archivio'],
  changes: ['/invii-da-modificare'],
  management: [
    '/gestione-general', '/allenamenti-basi', '/products', '/prodotti-acquistati', '/acquirenti-prodotti-lista',
    '/link-click-analytics', '/recuperoaccountdoppi', '/recuperoticketdoppi', '/questionari-template',
    '/questionari-users', '/questionari-users-scaduti', '/questionari-manuali', '/questionari-uid-fix',
    '/consulenze-tecniche-scalata', '/consulenze-riepilogo', '/percorsi-non-iniziati',
    '/import-program-history', '/import-orders', '/backfill-top-sku', '/procedure', '/check-dafare',
  ],
};

const activeIdByPath = new Map(
  Object.entries(sectionPaths).flatMap(([id, paths]) => paths.map((path) => [path, id]))
);

export function getStaffNavigationActiveId(route) {
  const path = typeof route?.path === 'string' ? route.path.replace(/\/+$/, '') || '/' : '';

  // This staff conversation also has a URL below /user, outside the profile layout.
  if (route?.name === 'UserConversationTecnica') return 'technical';

  const exactMatch = activeIdByPath.get(path);
  if (exactMatch) return exactMatch;

  if (/^\/assistenzanutrizionale\/conversation\/[^/]+$/.test(path)) return 'nutrition';
  if (/^\/assistenzatecnica\/conversation\/[^/]+$/.test(path)) return 'technical';
  if (/^\/orders-user\/[^/]+$/.test(path)) return 'orders';
  if (/^\/allenamenti-basi\/[^/]+$/.test(path)) return 'management';

  // Only the staff profile parent qualifies; customer /user routes are separate records.
  if (route?.matched?.some((record) => record.path === '/user/:userId')) return 'users';

  return null;
}
